import React, { useEffect, useState } from 'react'
import App from '../../../app/App'
import { redirectIfNeeded } from '../../../redirect/redirectIfNeeded'

const SolidsportRedirect: React.FC = () => {
  type RedirectUrl = {
    [key: string]: string
  }
  const redirectUrls: RedirectUrl = {
    'https://solidsport.com': 'https://www.solidsport.com',
    'https://solidsport.com/': 'https://www.solidsport.com',
    'https://sportstage.se': 'https://www.sportstage.se',
    'https://sportstage.se/': 'https://www.sportstage.se',
    'https://localhost': 'https://localhost/calendar',
    'https://localhost/': 'https://localhost/calendar',
    // Add the lines below to test from local environment
    'https://fabian-solidsport.dev': 'https://fabian-solidsport.dev/calendar',
    'https://fabian-solidsport.dev/': 'https://fabian-solidsport.dev/calendar',

    // App routes
    'solidsportapp://fabian-solidsport.dev':
      'solidsportapp://fabian-solidsport.dev/calendar',
    'solidsportapp://fabian-solidsport.dev/':
      'solidsportapp://fabian-solidsport.dev/calendar',

    'solidsportapp://solidsport.com': 'solidsportapp://solidsport.com/calendar',
    'solidsportapp://solidsport.com/':
      'solidsportapp://solidsport.com/calendar',

    'solidsportapp://local.sportstage.se:3000':
      'solidsportapp://local.sportstage.se:3000/calendar',
    'solidsportapp://local.sportstage.se:3000/':
      'solidsportapp://local.sportstage.se:3000/calendar',

    'https://local.sportstage.se:3000':
      'https://local.sportstage.se:3000/calendar',
    'https://local.sportstage.se:3000/':
      'https://local.sportstage.se:3000/calendar'
  }

  const [redirectCheckDone, setRedirectCheckDone] = useState(false)
  const [redirectUrl, setRedirectUrl] = useState<string>()
  const [thisIsTheWrongLocation, setThisIsTheWrongLocation] = useState(false)

  useEffect(() => {
    Object.keys(redirectUrls).forEach((k: string) => {
      if (k === window.location.href) {
        if (window.location.href !== redirectUrls[k]) {
          setRedirectUrl(redirectUrls[k])
        }
      }
    })
    if (
      !Object.keys(redirectUrls).includes(window.location.href) &&
      window.location.pathname === '/'
    ) {
      setThisIsTheWrongLocation(true)
    }
    setRedirectCheckDone(true)
  }, [])

  useEffect(() => {
    if (redirectCheckDone) {
      if (redirectUrl) {
        if (window.location.href !== redirectUrl) {
          window.location.href = redirectUrl
        }
      }
    }
  }, [redirectCheckDone, redirectUrl])

  useEffect(() => {
    if (thisIsTheWrongLocation) {
      redirectIfNeeded()
    }
  }, [thisIsTheWrongLocation])

  if (redirectCheckDone && !redirectUrl && !thisIsTheWrongLocation) {
    return <App />
  }

  return <></>
}

export default SolidsportRedirect
